export const getIsServer = (): boolean => typeof window === 'undefined'
